var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50036 5.49999C4.28101 5.49999 3.28991 4.51329 3.28991 3.29999C3.28991 2.08669 4.28101 1.09999 5.50036 1.09999C6.71971 1.09999 7.71081 2.08669 7.71081 3.29999C7.71081 4.51329 6.71971 5.49999 5.50036 5.49999ZM7.57716 5.87012C8.0316 5.50827 8.38205 5.03247 8.59286 4.49116C8.80366 3.94985 8.86728 3.36235 8.77725 2.78846C8.5589 1.34581 7.35331 0.191387 5.89746 0.0230873C3.88886 -0.209563 2.18496 1.34694 2.18496 3.29999C2.18496 4.33949 2.66896 5.26567 3.42356 5.87012C1.56896 6.56367 0.214863 8.19223 0.00256277 10.39C-0.00486005 10.4671 0.00388498 10.5449 0.0282349 10.6184C0.0525848 10.6919 0.092006 10.7596 0.143978 10.817C0.195949 10.8744 0.259327 10.9203 0.330061 10.9518C0.400794 10.9833 0.477328 10.9997 0.554765 11C0.690502 11.0011 0.821749 10.9515 0.922781 10.8608C1.02381 10.7701 1.08734 10.645 1.10091 10.5099C1.32256 8.05529 3.21071 6.59999 5.50036 6.59999C7.79001 6.59999 9.67815 8.05529 9.8998 10.5099C9.91337 10.645 9.9769 10.7701 10.0779 10.8608C10.179 10.9515 10.3102 11.0011 10.446 11C10.7738 11 11.029 10.7151 10.9976 10.39C10.7859 8.19223 9.43175 6.56367 7.5766 5.87012",
    fill: "#897E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8cce41e865450a3d7f4556677415f51f.svg";
export { ForwardRef as ReactComponent };